import React, {useEffect, useMemo, useState} from "react";
import Layout from "../../Shared/Layout";
import {
    Grid,
    Collapse,
    Box,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@material-ui/core";
import styled from "styled-components";
import {Inertia} from "@inertiajs/inertia";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import MuiButton from "@material-ui/core/Button";
import FormField from "../../Shared/FormField";
import {Field, Form as FinalForm} from "react-final-form";
import TextInput from "../../Shared/TextInput";
import {getCookieValue} from "../../utils/getCookieValue";
import {Trans} from "../../utils/i18n";
import {Alert} from "@material-ui/lab";
import {resolveClientConfig} from "../../utils/resolveClientConfig";
import Wrapper from "./Wrapper";
import { FormState } from "../../FormComponents/FormState";


const HR = styled.hr`
    display: flex;
    justify-content: flex-end;
    margin: 15px 0;
`;

const ResponseWrapper = styled.div`
    width: 100%;
    margin-top: 30px;
`;

const createConditionFilter = (values, state) => (fieldOrGroup, step) => {
    if (!fieldOrGroup.condition) {
        return true;
    }

    const paths = fieldOrGroup.condition.field
        .replace(/\[(.*)\]/gm, ".$1")
        .split(".");

    let value = paths.reduce((values, path) => values[path], values);

    if (fieldOrGroup.condition.compare === "!=") {
        if (value === undefined) {
            return null !== fieldOrGroup.condition.value;
        }
        return value !== fieldOrGroup.condition.value;
    }

    return value === fieldOrGroup.condition.value;
};

export default function Product({
                                    client,
                                    order,
                                    statuses,
                                    services,
                                    partners,
                                    coverages,
                                    settlements,
                                    materialOperations,
                                    files,
                                    userCanUpdate,
                                    orderattributes,
                                    orderhistories,
                                    extendedMode,
                                    permissions,
                                    returnUrl,
                                }) {
    const [formState, setFormState] = useState(undefined);
    const [response, setResponse] = useState(undefined);

    const onSubmit = async (data) => {
        setFormState("loading");
        await fetch(route("queue.store"), {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-XSRF-TOKEN": getCookieValue("XSRF-TOKEN"),
                "X-Requested-With": "XMLHttpRequest",
            },
            body: JSON.stringify({
                ...data,
                returnUrl,
            }),
        })
            .then((res) => res.json())
            .then((response) => {
                if (response.success) {
                    setFormState("success");
                    setResponse("");
                    Inertia.visit(
                        returnUrl ||
                        route("queue.index", {
                            requesttype: order.requesttype_key,
                        })
                    );
                    return;
                }
                setResponse(response);
                setFormState("error");
            })
            .catch(() => {
                setFormState("error");
            });
    };

    const [openIds, setOpenIds] = React.useState([]);

    return (
        <FormState>
            <Wrapper>
                <FinalForm initialValues={order} onSubmit={onSubmit}>
                    {({
                        handleSubmit,
                        submitting,
                        values,
                        form,
                        errors,
                        touched,
                    }) => {
                        const currentStatus = statuses.find(
                            (item) => item.id == values.status_id
                        );
                        const conditionFilter = useMemo(
                            () => createConditionFilter(values),
                            [values]
                        );
                        let preFix = "";

                        return (
                            <form onSubmit={handleSubmit}>
                                {extendedMode && order.permissions.product.update && (
                                    <div>
                                        <h3>
                                            <Trans i18nKey="queueDetail.serialNumber">
                                                Serial number
                                            </Trans>
                                        </h3>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} sm={6}>
                                                <Field
                                                    name={"serialnumber"}
                                                    type={"text"}
                                                    // placeholder={field.placeholder}
                                                    component={TextInput}
                                                    // validate={field.required ? validate[field.type] || required : undefined}
                                                    field={{
                                                        label: (
                                                            <Trans i18nKey="queueDetail.serialNumber">
                                                                Serial number
                                                            </Trans>
                                                        ),
                                                        type: "text",
                                                    }}
                                                    disabled={
                                                        submitting ||
                                                        !order.permissions.product
                                                            .update
                                                    }
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <Field
                                                    name={"outgoingSerialnumber"}
                                                    type={"text"}
                                                    // placeholder={field.placeholder}
                                                    component={TextInput}
                                                    // validate={field.required ? validate[field.type] || required : undefined}
                                                    field={{
                                                        label: (
                                                            <Trans i18nKey="queueDetail.outgoingSerialNumber">
                                                                Outgoing Serial
                                                                number
                                                            </Trans>
                                                        ),
                                                        type: "text",
                                                    }}
                                                    disabled={
                                                        submitting ||
                                                        !order.permissions.product
                                                            .update
                                                    }
                                                />
                                            </Grid>
                                        </Grid>
                                        <HR/>
                                    </div>
                                )}

                                <HR/>
                                <h3>
                                    <Trans i18nKey="queueDetail.products">
                                        Product / Accessories
                                    </Trans>
                                </h3>

                                <TableContainer>
                                    <Table
                                        size="small"
                                        aria-label={
                                            <Trans i18nKey="queueDetail.collapsibleTable">
                                                collapsible table
                                            </Trans>
                                        }
                                    >
                                        <TableHead>
                                            <TableRow>
                                                <TableCell/>
                                                <TableCell>
                                                    <Trans i18nKey="queueDetail.product">
                                                        Product
                                                    </Trans>
                                                </TableCell>
                                                <TableCell>
                                                    <Trans i18nKey="queueDetail.serialNumber">
                                                        Serial number
                                                    </Trans>
                                                </TableCell>
                                                {client.key == 'worldpay' || client.key == 'unzer' && (
                                                    <TableCell>
                                                        <Trans i18nKey="queueDetail.tid">
                                                            TID
                                                        </Trans>
                                                    </TableCell>
                                                )}
                                                <TableCell align="left">
                                                    <Trans i18nKey="queueDetail.quantity">
                                                        Quantity
                                                    </Trans>
                                                </TableCell>
                                                {client.key !== 'worldpay' && (
                                                    <TableCell><Trans i18nKey="queues.outgoingProduct">Outgoing
                                                        Product</Trans></TableCell>
                                                )}
                                                {client.key !== 'worldpay' && (
                                                    <TableCell><Trans i18nKey="queues.outgoingQuantity">Outgoing
                                                        Quantity</Trans></TableCell>
                                                )}
                                                {client.key !== 'worldpay' && (
                                                    <TableCell align="left">
                                                        <Trans i18nKey="queueDetail.problem">
                                                            Problem
                                                        </Trans>
                                                    </TableCell>
                                                )}
                                                <TableCell align="left">
                                                    <Trans i18nKey="queueDetail.problemDescription">
                                                        Problem description
                                                    </Trans>
                                                </TableCell>
                                                {client.key == 'worldpay' || client.key == 'xiaomi' && (
                                                    <TableCell align="left">
                                                        <Trans i18nKey="queueDetail.reference">
                                                            Order Line Ref
                                                        </Trans>
                                                    </TableCell>
                                                )}
                                                <TableCell align="left">
                                                    <Trans i18nKey="queueDetail.pop_date">
                                                        Purchase Date
                                                    </Trans>
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {order.products.map((product) => (
                                                <>
                                                    <TableRow key={product.number}>
                                                        <TableCell>
                                                            <IconButton
                                                                aria-label={
                                                                    <Trans i18nKey="queues.expandRow">
                                                                        expand row
                                                                    </Trans>
                                                                }
                                                                size="small"
                                                                onClick={() => {
                                                                    if (openIds.includes(product.id)) {
                                                                        return setOpenIds(array => array.filter(item => item !== product.id));
                                                                    }
                                                                    setOpenIds(array => [...array, product.id]);
                                                                }}
                                                                disabled={!product?.outgoingSerialnumbersList?.length}
                                                            >
                                                                {openIds.includes(product.id) ? (
                                                                    <KeyboardArrowUpIcon/>
                                                                ) : (
                                                                    <KeyboardArrowDownIcon/>
                                                                )}
                                                            </IconButton>
                                                        </TableCell>
                                                        <TableCell
                                                            component="th"
                                                            scope="row"
                                                        >
                                                            {product.description}
                                                        </TableCell>
                                                        <TableCell>
                                                            {product.serialnumber}
                                                        </TableCell>
                                                        {client.key == 'worldpay' || client.key == 'unzer' && (
                                                            <TableCell>
                                                                {product.tid}
                                                            </TableCell>
                                                        )}
                                                        <TableCell>
                                                            {product.quantity}
                                                        </TableCell>
                                                        {client.key !== 'worldpay' && (
                                                            <TableCell>{product.outgoingDescription}</TableCell>
                                                        )}
                                                        {client.key !== 'worldpay' && (
                                                            <TableCell>{product.outgoingQuantity}</TableCell>
                                                        )}
                                                        {client.key !== 'worldpay' && (
                                                            <TableCell>
                                                                {product.problem}
                                                            </TableCell>
                                                        )}
                                                        <TableCell>
                                                            {
                                                                product.problem_description
                                                            }
                                                        </TableCell>
                                                        {client.key == 'worldpay' || client.key == 'xiaomi' && (
                                                            <TableCell>
                                                                {product.reference}
                                                            </TableCell>
                                                        )}
                                                        <TableCell>
                                                            {product.pop_date}
                                                        </TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell
                                                            style={{
                                                                paddingBottom: 0,
                                                                paddingTop: 0,
                                                                width: "100%",
                                                            }}
                                                            colSpan={10}
                                                        >
                                                            <Collapse
                                                                in={openIds.includes(product.id)}
                                                                timeout="auto"
                                                                unmountOnExit
                                                            >
                                                                <Box margin={1} style={{marginLeft: 60}}>
                                                                    <h4>
                                                                        <Trans
                                                                            i18nKey="queueDetail.serialnumbersBelongingToTheProducts">
                                                                            Serialnumbers belonging to the products
                                                                        </Trans>:
                                                                    </h4>
                                                                    <Table size="small">
                                                                        <TableHead>
                                                                            <TableRow>
                                                                                {/*<TableCell>*/}
                                                                                {/*    <Trans i18nKey="queueDetail.product">*/}
                                                                                {/*        Product*/}
                                                                                {/*    </Trans>*/}
                                                                                {/*</TableCell>*/}
                                                                                <TableCell align="left">
                                                                                    <Trans i18nKey="queueDetail.type">
                                                                                        Type
                                                                                    </Trans>
                                                                                </TableCell>
                                                                                <TableCell>
                                                                                    <Trans
                                                                                        i18nKey="queueDetail.serialNumber">
                                                                                        Serial
                                                                                        number
                                                                                    </Trans>
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        </TableHead>
                                                                        <TableBody>
                                                                            {
                                                                                product.outgoingSerialnumbersList.map(item => (

                                                                                    <TableRow key={item.id}>
                                                                                        <TableCell
                                                                                            component="th"
                                                                                            scope="row"
                                                                                        >
                                                                                            {
                                                                                                item.type
                                                                                            }
                                                                                        </TableCell>
                                                                                        <TableCell>
                                                                                            {
                                                                                                item.serialnumber
                                                                                            }
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                    // <BadgeStyleLi key={item.id}>{item.serialnumber}</BadgeStyleLi>
                                                                                ))
                                                                            }
                                                                        </TableBody>
                                                                    </Table>
                                                                </Box>
                                                            </Collapse>
                                                        </TableCell>
                                                    </TableRow>
                                                </>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>

                                {!extendedMode && resolveClientConfig(client.key) &&
                                    resolveClientConfig(client.key).groups.map(
                                        (group, index) => {
                                            const fields = group.fields.map(
                                                (field, index) => {
                                                    const size =
                                                        resolveClientConfig(
                                                            client.key
                                                        ).sizes[
                                                            field.size
                                                                ? field.size
                                                                : "full"
                                                            ];

                                                    return (
                                                        (field.conditionFunction
                                                            ? field.conditionFunction(
                                                                values,
                                                                {statuses}
                                                            )
                                                            : true) &&
                                                        conditionFilter(field) && (
                                                            <Grid
                                                                key={index}
                                                                item
                                                                xs={12}
                                                                sm={size}
                                                            >
                                                                <FormField
                                                                    disabled={
                                                                        field.disabledFunction
                                                                            ? field.disabledFunction(
                                                                                values
                                                                            )
                                                                            : false
                                                                    }
                                                                    field={field}
                                                                    preFix={preFix}
                                                                    submitting={
                                                                        submitting
                                                                    }
                                                                    values={values}
                                                                    form={form}
                                                                    mutators={
                                                                        form.mutators
                                                                    }
                                                                    requesttypes={[]}
                                                                />
                                                            </Grid>
                                                        )
                                                    );
                                                }
                                            );
                                            return (
                                                (group.conditionFunction
                                                    ? group.conditionFunction(
                                                        values,
                                                        {statuses}
                                                    )
                                                    : true) &&
                                                conditionFilter(group) && (
                                                    <div key={index}>
                                                        <div>
                                                            <div>
                                                                {group.heading && (
                                                                    <h3>
                                                                        {
                                                                            group.heading
                                                                        }
                                                                    </h3>
                                                                )}
                                                                {group.description && (
                                                                    <p>
                                                                        {
                                                                            group.description
                                                                        }
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <Grid container spacing={3}>
                                                            {fields}
                                                        </Grid>
                                                        {resolveClientConfig(
                                                                client.key
                                                            ).groups.length >
                                                            index + 1 && <hr/>}
                                                    </div>
                                                )
                                            );
                                        }
                                    )}

                                <div className={'flex justify-end gap-3 mt-10'}>
                                    {permissions.includes(
                                        "queue_shipping_label"
                                    ) && (
                                        <MuiButton
                                            variant="contained"
                                            color={"primary"}
                                            disabled={
                                                submitting ||
                                                currentStatus.key === "created" ||
                                                currentStatus.key === "closed" ||
                                                currentStatus.key === "canceled"
                                            }
                                            href={route("queue.shippinglabel", {
                                                ordernumber: order.number,
                                            })}
                                            target="_blank"
                                        >
                                            <Trans i18nKey="queueDetail.shippingLabelButton">
                                                CREATE SHIPPING LABEL
                                            </Trans>
                                        </MuiButton>
                                    )}
                                    {extendedMode && (
                                        <MuiButton
                                            variant="contained"
                                            disabled={submitting}
                                            onClick={() =>
                                                Inertia.visit(
                                                    route("queue.index", {
                                                        requesttype:
                                                        order.requesttype_key,
                                                    })
                                                )
                                            }
                                        >
                                            <Trans i18nKey="queueDetail.cancel">
                                                Cancel
                                            </Trans>
                                        </MuiButton>
                                    )}
                                    <MuiButton
                                        variant="contained"
                                        color={"secondary"}
                                        disabled={
                                            submitting ||
                                            !order.permissions.product.update
                                        }
                                        type={"submit"}
                                        onClick={() => {
                                            form.change("saveAndCloseJob", false);
                                        }}
                                    >
                                        <Trans i18nKey="queueDetail.save">
                                            Save
                                        </Trans>
                                    </MuiButton>
                                    {extendedMode == false && (
                                        <MuiButton
                                            variant="contained"
                                            color={"secondary"}
                                            disabled={
                                                submitting ||
                                                !order.permissions.product.update ||
                                                currentStatus.key === "closed"
                                            }
                                            type={"submit"}
                                            onClick={() => {
                                                form.change(
                                                    "saveAndCloseJob",
                                                    true
                                                );
                                            }}
                                        >
                                            <Trans i18nKey="queueDetail.saveAndClose">
                                                Save & close job
                                            </Trans>
                                        </MuiButton>
                                    )}
                                    <br/>
                                </div>
                                <ResponseWrapper>
                                    {response?.message && (
                                        <Alert severity="warning">
                                            {response?.message}
                                        </Alert>
                                    )}
                                </ResponseWrapper>
                            </form>
                        );
                    }}
                </FinalForm>
            </Wrapper>
        </FormState>
    );
}

Product.layout = (page) => <Layout children={page}/>;
